import React from 'react';
import { COLORS } from '@constants';
import { Button } from '@ui';
import { Flex } from 'antd';

export const CancelSubmit = ({ style, onCancel, cancelText = 'Cancel', submitText = 'Submit', disabled, loading }) => {
    return (
        <Flex style={style} justify='end' gap={16}>
            {cancelText && (
                <Button style={{ width: 160 }} backgroundColor={COLORS.$white} block onClick={onCancel || (() => {})}>
                    {cancelText}
                </Button>
            )}
            {submitText && (
                <Button htmlType='submit' type='primary' style={{ width: 160 }} loading={loading} disabled={disabled}>
                    {submitText}
                </Button>
            )}
        </Flex>
    );
};
